export interface RequestBody {
  firstName: string;
  lastName: string;
  email: string;
  agreeTerms: boolean;
  agreeSuscription: boolean;
  token: string;
}

const sendUserInfo = async (body: RequestBody): Promise<Response> => {
  const response = await fetch(`${process.env.DOWNLOAD_FORM_END_POINT}`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    body: JSON.stringify({
      'First_Name': body.firstName,
      'Last_Name': body.lastName,
      'EmailAddress': body.email,
      'Agreed_To_Terms': body.agreeTerms,
      'Signed_Up_For_Email_Offers': body.agreeSuscription,
      'token': body.token,
    }),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  return response;
};

export { sendUserInfo };
